import angular from "angular";
import { BroadcastService } from "@common/service/broadcast.service";

export interface IEcvMugshotList {
    filter: Function;
    validateEntity: Function;
    entities: any[];

    addParams: any;
    mugshotType: string;
    maxLimit: number;
    size: string;
    init: Function;

    setFilteredEntities();
}

class EcvMugshotList implements IEcvMugshotList {
    filter: Function;
    underEntities: any[];
    overEntities: any[];
    validateEntity: Function;
    entities: any[];
    mugshotType: string;
    addParams: any;
    maxLimit: number;
    size: string;
    object: any;
    enterpriseBranding: boolean;
    apndToParent: boolean;
    isTooltipOpen: boolean;
    $_scope: angular.IScope;
    static $inject = ["BroadcastService", "$scope"];
    displayBadge: boolean;
    constructor(
        private BroadcastService: BroadcastService,
        private $scope: angular.IScope
    ) {
        this.$_scope = $scope;
        // any conditions which should be fulfilled to display this mugshot
        // should be passed as a function using the filter attribute
        this.validateEntity = (entity: any) => {
            if (!!this.filter) {
                // any additional params you have used in your filter can be passed
                // using add-params attribute and will be available in your filter
                // with same name
                return this.filter(entity, this.addParams);
            } else {
                return true;
            }
        };
        $scope.$on("$destroy", () => {
            BroadcastService.removeCallBack("mugshot-tooltip-hide", $scope.$id);
        });
    }

    setFilteredEntities = (): void => {
        let filteredEntities = !!this.filter
            ? this.entities.filter((et) => this.filter(et, this.addParams))
            : this.entities.slice(0);
        this.underEntities = !!this.maxLimit
            ? filteredEntities.slice(0, this.maxLimit)
            : filteredEntities;
        this.overEntities =
            !!this.maxLimit && this.maxLimit < filteredEntities.length
                ? filteredEntities.slice(this.maxLimit)
                : null;
    };

    getFilteredCount = (): number => {
        return this.overEntities.length + this.underEntities.length;
    };

    init = () => {
        this.setFilteredEntities();
        // if (!!this.object) {
        //     console.log("List entities for", !!this.object.assignmentId ? this.object.assignmentId : this.object.id,":", this.entities, this.underEntities, this.overEntities)
        // }
        // if (!this.maxLimit) {
        //   this.maxLimit = undefined;
        // }

        // else {
        // if (this.maxLimit > 0) {
        //   this.maxLimit += 1;
        // } else {
        //   this.maxLimit -= 2;
        // }
        // }

        typeof this.displayBadge == "undefined" && (this.displayBadge = true);
        !this.size && (this.size = "medium");
        !this.mugshotType && (this.mugshotType = "tm");
        // console.log("Mugshot List:\n\tmaxLimit:",this.maxLimit,"\n\tlist:",this.entities,"\n\tFiltered Entities:", this.underEntities, this.overEntities);
        this.BroadcastService.registerCallBack(
            "mugshot-tooltip-hide",
            this.$_scope.$id,
            (data) => {
                this.isTooltipOpen = false;
            }
        );
    };
}

function mugshotList(): ng.IDirective {
    return {
        restrict: "E",
        templateUrl: "app/common/mugshotList/mugshot-list.directive.html",
        replace: true,
        controller: EcvMugshotList,
        controllerAs: "mugshotListVm",
        scope: true,
        bindToController: {
            entities: "=?entities",
            filter: "=?filter",
            addParams: "=?addParams",
            maxLimit: "@?maxLimit",
            mugshotType: "@?mugshotType",
            size: "@?size",
            object: "=?object",
            enterpriseBranding: "=",
            apndToParent: "=",
            displayBadge: "=?",
            tooltipPlacement: "=?",
        },
        link: (
            scope: ng.IScope,
            element: ng.IAugmentedJQuery,
            attributes: ng.IAttributes,
            controller: IEcvMugshotList
        ): void => {
            controller.init();

            scope.$watch(
                () => {
                    return controller.entities;
                },
                () => {
                    controller.setFilteredEntities();
                },
                true
            );
        },
    };
}

angular
    .module("eCareVault.common.mugshotList")
    .directive("ecvMugshotList", mugshotList);
